import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledArchitectureSection = styled.section`
  max-width: 900px;

  p {
    margin-top: 20px;
  }

  .architecture-box {
    background: var(--light-navy);
    padding: 30px;
    border-radius: var(--border-radius);
    font-family: var(--font-mono);
    line-height: 1.8;
    margin-top: 25px;
    overflow-x: auto;
  }

  ul {
    margin-top: 25px;
  }

  li {
    margin-bottom: 10px;
  }
`;

const Architecture = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) return;
    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledArchitectureSection id="architecture" ref={revealContainer}>
      <h2 className="numbered-heading">
        System Architecture – Real-Time Health Monitoring Platform
      </h2>

      <p>
        The platform follows a backend-centric architecture where wearable
        devices and client applications communicate with a centralized backend
        service. Telemetry data can be sent directly from the wearable device
        or through a mobile companion application.
      </p>

      <div className="architecture-box">
        <pre>
{`Wear OS Device
      │
      │ BLE / Internet
      ▼
Android Companion App (optional)
      │
      │ REST API
      ▼
Node.js Backend
      │
      ▼
PostgreSQL Database
      │
      ▼
Web Dashboard (Next.js)
`}
        </pre>
      </div>

      <ul>
        <li>Wear OS device collects health metrics using SensorManager APIs.</li>
        <li>Telemetry can be transmitted directly to the backend or via an Android companion app.</li>
        <li>Android application handles BLE communication and forwards sensor data.</li>
        <li>Node.js backend processes telemetry data and stores it in PostgreSQL.</li>
        <li>Web dashboard visualizes real-time health metrics and historical trends.</li>
      </ul>
    </StyledArchitectureSection>
  );
};

export default Architecture;